<template>
  <b-modal
    v-model="showModal"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="xl"
    scrollable
    no-close-on-backdrop
  >
    <template #modal-title>
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="text-uppercase text-primary py-0 my-0">{{ title }}</h5>
      </div>
    </template>

    <b-row class="modal-listado-trabajo-adicional">
      <b-col md="12" lg="12" xl="12">
        <b-table small responsive hover :items="items" :fields="fields">
          <template #cell(archivo)="data">
            <feather-icon
              v-if="data.item.archivo"
              icon="FileIcon"
              class="text-primary cursor-pointer"
              @click="openFile(data.item.archivo)"
            ></feather-icon>
            <span v-else>-</span>
          </template>
          <template #cell(estado)="data">
            <b-badge
              :variant="getVariant(data.item.estado)"
              class="text-uppercase"
            >
              {{ data.item.estado }}
            </b-badge>
          </template>
          <template #cell(created_at)="data">
            {{ data.item.created_at | myGlobalDay }}
          </template>
          <template #cell(remunerable)="data">
            <b-badge
              :variant="
                data.item.remunerable ? 'light-success' : 'light-danger'
              "
            >
              <span class="text-uppercase">
                {{ data.item.remunerable ? "SI" : "NO" }}
              </span>
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="
                data.item.estado === 'pendiente' &&
                data.item.empleado_id === currentUser.employee_id
              "
              size="sm"
              variant="outline-primary"
              class="mr-1"
              @click="editarTrabajoAdicional(data.item.id)"
            >
              EDITAR
            </b-button>
            <b-button
              v-if="
                data.item.estado === 'pendiente' &&
                data.item.empleado_id === currentUser.employee_id
              "
              size="sm"
              variant="outline-danger"
              @click="actualizarEstadoTrabajoAdicional(data.item.id, 'anulado')"
            >
              ANULAR
            </b-button>
            <b-button
              v-if="data.item.estado !== 'pendiente'"
              size="sm"
              variant="outline-primary"
              @click="openHistorialTrabajoAdicionalModal(data.item.id)"
            >
              <feather-icon icon="ListIcon"></feather-icon>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <TrabajoAdicionalHistorialModal
      v-if="showTrabajoAdicionalHistorialModal"
      :id="idTrabajoAdicional"
      @close="
        (showTrabajoAdicionalHistorialModal = false),
          (idTrabajoAdicional = null)
      "
    />

    <TrabajoAdicionalModal
      v-if="showTrabajoAdicionalModal"
      :id="idTrabajoAdicional"
      @close="(showTrabajoAdicionalModal = false), (idTrabajoAdicional = null)"
      @update="
        (showTrabajoAdicionalModal = false), getTrabajoAdicionalPorEmpleado()
      "
    />
  </b-modal>
</template>

<script>
import Fields from "@/views/rrhh/views/trabajo-adicional/data/fields.data.js";
import { mapGetters } from "vuex";
import TrabajoAdicionalService from "@/views/rrhh/views/trabajo-adicional/services/trabajo.adicional.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import TrabajoAdicionalHistorialModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalHistorialModal.vue";
import TrabajoAdicionalModal from "@/views/rrhh/views/trabajo-adicional/components/TrabajoAdicionalModal.vue";
export default {
  components: {
    ToastificationContent,
    TrabajoAdicionalHistorialModal,
    TrabajoAdicionalModal,
  },
  data() {
    return {
      fields: Fields,
      showModal: true,
      showTrabajoAdicionalHistorialModal: false,
      showTrabajoAdicionalModal: false,
      items: [],
      idTrabajoAdicional: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    title() {
      return `Listado de trabajo adicional: ${this.currentUser.fullName}`;
    },
  },
  mounted() {
    this.getTrabajoAdicionalPorEmpleado();
  },
  methods: {
    async getTrabajoAdicionalPorEmpleado() {
      try {
        this.addPreloader();
        const params = {
          id_personal: this.currentUser.employee_id,
        };
        const { data } =
          await TrabajoAdicionalService.getTrabajoAdicionalPorEmpleado(params);

        this.items = data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async actualizarEstadoTrabajoAdicional(id, estado) {
      try {
        const { isConfirmed } = await this.showConfirmSwal();
        if (!isConfirmed) {
          return;
        }

        this.addPreloader();
        const params = {
          id,
          estado,
        };
        const { data } =
          await TrabajoAdicionalService.actualizarEstadoTrabajoAdicional(
            params
          );
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.getTrabajoAdicionalPorEmpleado();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    getVariant(estado) {
      switch (estado) {
        case "pendiente":
          return "light-warning";
        case "aprobado":
          return "light-success";
        case "rechazado":
          return "light-danger";
        case "anulado":
          return "light-secondary";
        default:
          return "light-primary";
      }
    },
    openHistorialTrabajoAdicionalModal(id) {
      this.showTrabajoAdicionalHistorialModal = true;
      this.idTrabajoAdicional = id;
    },
    editarTrabajoAdicional(id) {
      this.showTrabajoAdicionalModal = true;
      this.idTrabajoAdicional = id;
    },
  },
};
</script>

<style lang="scss">
.modal-listado-trabajo-adicional {
  .custom-dark {
    background-color: #111113 !important;
  }

  .custom-light {
    background-color: #f8f9fa !important;
  }

  .card .card-title {
    margin-bottom: 0.5rem;
  }
}
</style>